import _NoticeBar from './NoticeBar';

import './style/index.js';

export type { NoticeBarProps } from './NoticeBar';

export * from './type';

export const NoticeBar = _NoticeBar;

export default NoticeBar;

